module.exports = __webpack_public_path__ + "static/media/Logo_PICSUP_black.b9cdac2c.png";